/**
 * Client entry point
 *
 * Hydrates the React application client-side.
 * The HTML has already been generated by the server (SSR).
 */

import '@wordpress/block-library/build-style/style.css';
import '@wordpress/block-library/build-style/theme.css';
import '../styles/main.scss';
import 'virtual:theme-tokens.css';
import 'virtual:uno.css';
// UnoCSS browser runtime: generates atomic CSS for classes present only in
// WordPress-rendered markup (e.g. the humanoid-gutenberg/plan block) that the
// build-time scan never sees. Mirrors the SSR inline generation so styles are
// correct both at first paint (SSR) and after hydration (CSR).
import '../uno-runtime';

import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from '../App';
import { initClickrefDelegation } from '../utils/clickref-dom';
import { initAnalytics } from '@humanoidfr/scripts/analytics';
import { initOfferClickTracking } from '../analytics/offerClicks';

// Data is injected by the server into window.__APP_DATA__
const data = window.__APP_DATA__;

initClickrefDelegation();
// Offer clicks are pushed to the dataLayer whatever the consent; the bridge
// forwards them to PostHog only once the head tag has initialised it.
initOfferClickTracking();
initAnalytics();

// Hydration: React takes control of the existing DOM
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <App data={data} />
  </StrictMode>
);
